import { useState } from 'react';
import { Box } from '@material-ui/core';
import _ from 'lodash';
import moment from 'moment';
import Dialog from '../../../components/Dialog';
import Text from '../../../components/Text';
import StyleInput from '../../../components/StyleInput';
import AutoCompleteCheckbox from '../../../components/AutoCompleteCheckbox';
import { useGetUserInfo } from '../../../utils';
import useForward from '../../../utils/useForward';
import { SearchIcon } from '../../../components/Icon';
import { patientSurveyAPI } from '../../../apis';
import { useGetLoginInfo } from '../../../utils/hooks';
import { i18n } from '../../../language';

const ShareSurveyPopup = ({ handleClose, responseId, handleConfirm }) => {
  const userInfo = useGetUserInfo();
  const loginInfo = useGetLoginInfo();
  const [formData, setFormData] = useState({
    from: loginInfo.displayName,
    roomTypeList: [],
  });
  const roomTypeList = useForward(true);
  const isProAdmin = userInfo?.roleTypeId === 7;

  const handleUpdate = (type) => (value) => {
    setFormData((prev) => {
      if (type === 'roomTypeList') {
        if (prev[type].some((item) => item.value === 6)) {
          return {
            ...prev,
            [type]: _.filter(value, (item) => item.value !== 6),
          };
        } else if (_.some(value, (item) => item.value === 6)) {
          return {
            ...prev,
            [type]: [_.find(value, (item) => item.value === 6)],
          };
        } else {
          return {
            ...prev,
            [type]: value,
          };
        }
      }
      return {
        ...prev,
        [type]: value,
      };
    });
  };

  const handleShare = async () => {
    try {
      const params = {
        from: formData.from,
        responseId,
        roomType: _.map(formData.roomTypeList, (item) => item.value),
        postDay: moment().format('YYYY-MM-DD HH:mm:ss'),
        wardId: isProAdmin ? null : userInfo.wardId,
      };
      await patientSurveyAPI.sharePatientSurvey(params);
      handleConfirm();
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Dialog
      open={true}
      title={`Share to ${i18n.t('EHANDOVER_EHANDOVER')} and HA Chat`}
      cancel="Cancel"
      confirm="Share"
      handleCancel={handleClose}
      handleClose={handleClose}
      handleConfirm={handleShare}
      disabled={formData.roomTypeList.length === 0}
    >
      <Box display="flex" flexDirection="column">
        <Text fontSize="0.875rem" color="#666666">
          From
        </Text>
        <StyleInput
          value={formData.from}
          onChange={handleUpdate('from')}
          style={{ marginBottom: '1.88rem', marginTop: '0.75rem' }}
          inputProps={{ maxLength: 80 }}
          placeholder="Corp Id"
        />
        <AutoCompleteCheckbox
          itemList={roomTypeList.filter((item) => item.value !== 5)}
          value={formData.roomTypeList}
          onChange={handleUpdate('roomTypeList')}
          placeholder="Select group"
          allItem={false}
          dropDownIcon
          endAdornment={<SearchIcon style={{ fontSize: '1.5rem', color: '#538FFF', transform: 'translateX(-1rem)' }} />}
        />
      </Box>
    </Dialog>
  );
};

export default ShareSurveyPopup;
